import { Box } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import AddButtonRounded from '@Components/AddButtonRounded';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { useDisclosure } from '@hooks/useDisclosure';
import ProductIncomeModal from '../ProductIncomeModal/ProductIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

const ProductIncomeAddButton = () => {
  const [opened, { open, close }] = useDisclosure();
  const { watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <Flex gap={1} mt={2}>
        <Box width={1} minWidth={235} maxWidth={350} />
        <Box
          ml={1}
          width={1}
          display={'grid'}
          gridTemplateColumns={'1fr'}
          gap={3}
        >
          <AddButtonRounded
            name="เพิ่มสายผลิตภัณฑ์หรือกลุ่มธุรกิจ"
            onClick={open}
            disabled={isCompletedTh || isCompletedEn}
          />
        </Box>
      </Flex>
      {opened && (
        <ProductIncomeModal mode="create" open={opened} close={close} />
      )}
    </>
  );
};

export default ProductIncomeAddButton;
